<template>
    <aside class="leaf notice no-print" aria-labelledby="release-notes-title">
        <button type="button" class="btn btn-quiet btn-sm btn-icon close" aria-label="Schliessen" @click="dismiss">
            <X aria-hidden="true" />
        </button>
        <h2 id="release-notes-title" class="leaf-title">{{ title }}</h2>
        <ul>
            <li v-for="(item, index) in items" :key="index">{{ item }}</li>
        </ul>
        <div class="actions">
            <button type="button" class="btn btn-primary btn-sm" @click="dismiss">Verstanden</button>
        </div>
    </aside>
</template>

<script>
import { X } from '@lucide/vue';

export default {
    name: 'ReleaseNotes',
    components: { X },
    props: {
        title: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    },
    emits: ['dismiss'],
    methods: {
        dismiss() {
            this.$emit('dismiss');
        }
    }
}
</script>

<style scoped>
/* A paper leaf in the bottom right corner, above the page; full width on phones. */
.notice {
    position: fixed;
    right: var(--gutter);
    bottom: var(--gutter);
    z-index: 30;
    width: min(380px, calc(100vw - 2 * var(--gutter)));
    padding: var(--s-5);
    display: grid;
    gap: var(--s-3);
    box-shadow: var(--shadow-lg);
}

.leaf-title {
    padding-right: var(--s-6);
}

.close {
    position: absolute;
    top: var(--s-2);
    right: var(--s-2);
}

ul {
    display: grid;
    gap: var(--s-1);
    margin: 0;
    padding-left: 1.2em;
    font-size: var(--t-sm);
    font-weight: 600;
    color: var(--ink-2);
}

@media (prefers-reduced-motion: no-preference) {
    .notice {
        animation: rise var(--dur-slow) var(--ease);
    }
}

@keyframes rise {
    from {
        transform: translateY(8px);
        opacity: 0;
    }
}
</style>
